import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import { Button, FileField, FileInput, TextInput, required, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const AddDocumentDialog = ({ url, triggerLabel = "Добави документ" }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      url,
      { name: data.name, file: data.file },
      "POST",
      null,
      true,
    );
    notify("Документът е добавен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добавяне на документ"
      saveTitle="Добави"
      dialogSize="md"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label={triggerLabel}
          variant="contained"
          startIcon={<AddIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="name"
            label="Име на документа"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <FileInput
            source="file"
            label="Файл"
            accept={{ "application/pdf": [".pdf"], "image/*": [".png", ".jpg", ".jpeg"] }}
            validate={required("Задължително")}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default AddDocumentDialog;
